import { Document } from '@work4all/models/lib/Classes/Document.entity';
import { Letter } from '@work4all/models/lib/Classes/Letter.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

type AttachableDocumentEntities = Document | Letter;

const ENTITIES_WITH_ATTACHMENTS_TO_COPY = [Entities.document, Entities.letter];

const getEntriesAttachmentsIds = (
  entity: Entities,
  entries: AttachableDocumentEntities[]
) => {
  switch (entity) {
    case Entities.document:
      return entries.flatMap((entry: Document) => {
        const childDocuments = entry.childDocuments ?? [];
        const childDocumentIds = childDocuments.map((doc) => doc.id.toString());

        return [entry.id.toString(), ...childDocumentIds];
      });

    case Entities.letter:
      return entries.map((entry: Letter) => {
        return entry.id.toString();
      });

    default:
      return [];
  }
};

export function buildConvertTemplateAndParams(
  entity: Entities,
  convertTo: Entities,
  entries: { id?: string | number }[]
): {
  template: { entity: Entities; ids: (string | number)[] } | null;
  params: Record<string, string> | null;
} {
  let template: { entity: Entities; ids: (string | number)[] } | null = null;
  let params: Record<string, string> | null = null;

  const selectedIds = entries.map((x) => x.id);

  if (
    ENTITIES_WITH_ATTACHMENTS_TO_COPY.includes(entity) &&
    selectedIds.length !== 0
  ) {
    params = {
      attachmentsToCopy: JSON.stringify({
        entity,
        ids: getEntriesAttachmentsIds(
          entity,
          entries as unknown as AttachableDocumentEntities[]
        ),
      }),
    };
  }

  if (selectedIds.length === 1) {
    template = { entity, ids: [selectedIds[0]] };
  } else if (Entities.document === entity && Entities.eMail === convertTo) {
    template = { entity, ids: selectedIds };
  }

  return { template, params };
}
